// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604021703/js/" + chunkId + "." + {"44":"ecc4db67","225":"6e370880","481":"57298ada","486":"e8a9cb90","770":"420afa68"}[chunkId] + ".0.1958895317934719.chunk.js";
};